import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store/store';
import App from "./App";
const store = configureStore();

store.subscribe(()=>{
    localStorage.setItem('persistState', JSON.stringify(store.getState()))
})

render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js